import { Component, ContentChild, ElementRef, Input, OnInit } from '@angular/core';
import { InputText } from 'primeng/inputtext';
import { Password } from 'primeng/password';
import { Select } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { Nullable } from 'primeng/ts-helpers';

import { ValidationService } from '@/service/validation.service';

@Component({
    selector: 'app-verifiable-input',
    template: `
        <div class="relative w-full flex">
            @if (error) {
                <i style="position: absolute; left: 0; top: 0; transform: translate(-50%, -50%)"
                   class="pi pi-exclamation-triangle cursor-help z-5 text-2xl text-red-500"
                   [pTooltip]="error"></i>
            }
            <div class="flex-1">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    standalone: true,
    imports: [TooltipModule]
})
export class VerifiableInput implements OnInit {
    @Input() group!: string;
    @Input() field!: string;

    error: Nullable<string>;

    @ContentChild(InputText) inputText!: InputText;
    @ContentChild(Password) password!: Password;
    @ContentChild(Select) select!: Select;

    @ContentChild('', { read: ElementRef }) host!: ElementRef;

    constructor(private validationService: ValidationService) {}

    ngOnInit(): void {
        this.validationService.getError$(this.group, this.field).subscribe((e) => {
            this.error = e ?? null;
            this.applyErrorClass(!!this.error);
        });
    }

    private applyErrorClass(hasError: boolean): void {
        const className = 'p-invalid';

        if (this.inputText) {
            this.inputText.el.nativeElement.classList.toggle(className, hasError);
            return;
        }

        if (this.password) {
            this.password.input.nativeElement.classList.toggle(className, hasError);
            return;
        }

        if (this.select) {
            this.select.el.nativeElement.classList.toggle(className, hasError);
            return;
        }

        if (this.host) {
            this.host.nativeElement.classList.toggle(className, hasError);
        }
    }
}
